import React from "react";
import { Notice } from "@cadenza/shared-staticpages";
import { useLanguageContext } from "@cadenza/i18n-react";
import { APP } from "@cadenza/i18n-core";

const NoticeI18n = (props) => {
  const { language, STRINGS = {} } = useLanguageContext() || {};

  const message = STRINGS[APP.TRANSLATION_NOTICE];

  return <Notice message={message} appLang={language} {...props} />;
};

export default NoticeI18n;
